import script from "./manageSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./manageSearch.vue?vue&type=script&setup=true&lang=ts"

import "./manageSearch.vue?vue&type=style&index=0&id=163c2e9a&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-163c2e9a"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QTooltip,QIcon});
